import client from 'core/axios';
import handleError from 'core/axios/handleError';
import { handleJSONResponse } from 'core/axios/handleResponse';
import RequestMethod from 'core/axios/RequestMethod';

export const getMyInterviewContext = ({ version = 'v1' }) =>
  client
    .request({
      url: `${version}/video-qna/my-interview/context/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getMentorContext = ({ version = 'v1' }) =>
  client
    .request({
      url: `${version}/video-qna/mentor-context/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getQuestionList = ({ version = 'v1', params = {} }) =>
  client
    .request({
      url: `${version}/video-qna/qna-questions/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const askQuestion = ({ version = 'v1', payload }) =>
  client
    .request({
      url: `${version}/video-qna/qna-questions/`,
      method: RequestMethod.POST,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getVideoList = ({ version = 'v1', params = {} }) =>
  client
    .request({
      url: `${version}/video-qna/qna-videos/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getMemberDashboardVideoList = ({ version = 'v1', params = {} }) =>
  client
    .request({
      url: `${version}/video-qna/qna-videos/member-dashboard/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getVideo = ({ version = 'v1', videoId }) =>
  client
    .request({
      url: `${version}/video-qna/qna-videos/${videoId}/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const createVideo = ({ version = 'v1', payload }) =>
  client
    .request({
      url: `${version}/video-qna/qna-videos/`,
      method: RequestMethod.POST,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const deleteVideo = ({ version = 'v1', videoId }) =>
  client
    .request({
      url: `${version}/video-qna/qna-videos/${videoId}`,
      method: RequestMethod.DELETE,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const likeVideo = ({ version = 'v1', qnaVideo }) =>
  client
    .request({
      url: `${version}/video-qna/like/`,
      method: RequestMethod.POST,
      data: { qnaVideo },
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const unlikeVideo = ({ version = 'v1', qnaVideo }) =>
  client
    .request({
      url: `${version}/video-qna/like/`,
      method: RequestMethod.DELETE,
      data: { qnaVideo },
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const viewVideo = ({ version = 'v1', qnaVideo }) =>
  client
    .request({
      url: `${version}/video-qna/view/`,
      method: RequestMethod.POST,
      data: { qnaVideo },
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const createMobileLink = ({ version = 'v1', payload }) =>
  client
    .request({
      url: `${version}/video-qna/mobile-link/`,
      method: RequestMethod.POST,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getMobileLink = ({ version = 'v1', hashId }) =>
  client
    .request({
      url: `${version}/video-qna/mobile-link/${hashId}/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);
